<template>
  <el-dialog :title="dialogTitle" :visible="show" @open="init" @close="closeDialog" :close-on-click-modal="false" width="600px">
    <el-form :model="form" :rules="rules" ref="form" label-width="180px">
      <el-form-item :label="$t('text.cardName')" prop="bankCardInfoId">
        <el-select v-model="form.bankCardInfoId" filterable :placeholder="$t('message.chooseOne')" :disabled="bankCardSelectorDisabled">
          <el-option-group :label="$t('text.unbound')">
            <el-option v-for="card in availableCards" :key="card.name" :label="card.name" :value="card.value" :disabled="false"/>
          </el-option-group>
          <el-option-group :label="$t('text.bound')">
            <el-option v-for="card in boundCards" :key="card.name" :label="card.name" :value="card.value" :disabled="true"/>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.sender')" prop="sender">
        <el-input v-model="form.sender" auto-complete="off" :placeholder="$t('message.inputSender')"/>
      </el-form-item>
      <el-form-item :label="$t('text.recipient')" prop="recipient">
        <el-input v-model="form.recipient" auto-complete="off" :placeholder="$t('message.inputRecipient')"/>
      </el-form-item>
      <el-form-item :label="$t('text.mailServiceHost')" prop="mailHost">
        <el-input v-model="form.mailHost" auto-complete="off" :placeholder="$t('message.inputMailHost')"/>
      </el-form-item>
      <el-form-item :label="$t('text.mailServicePort')" prop="mailPort">
        <el-input v-model.number="form.mailPort" auto-complete="off" :placeholder="$t('message.inputMailPort')"/>
      </el-form-item>
      <el-form-item :label="$t('text.mailServiceUsername')" prop="username">
        <el-input v-model="form.username" auto-complete="off" :placeholder="$t('message.inputMailUsername')"/>
      </el-form-item>
      <el-form-item :label="$t('text.mailServicePassword')" prop="password">
        <el-input v-model="form.password" auto-complete="off" :placeholder="$t('message.inputMailPassword')"/>
      </el-form-item>
      <el-form-item :label="$t('text.status')" prop="enabled">
        <el-select v-model.number="form.enabled" :placeholder="$t('message.chooseOne')">
          <el-option :label="$t('option.null')" :value="null"/>
          <el-option :label="$t('text.enabled')" :value="true"/>
          <el-option :label="$t('text.disabled')" :value="false"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: "MailMonitorInfoEdit",
  props: {
    show: Boolean,
    value: Object,
    action: String
  },
  computed: {
    dialogTitle() {
      return this.action === "edit" ? this.$t("text.editAccount") : this.$t("text.addAccount");
    },
    bankCardSelectorDisabled() {
      return this.action === "edit";
    },
    availableCards() {
      return this.bankCardList.filter(item => !item.disabled);
    },
    boundCards() {
      return this.bankCardList.filter(item => item.disabled);
    }
  },
  data() {
    return {
      dialogShow: this.show,
      bankCardList: [],
      form: this.newFormData(),
      rules: {
        bankCardInfoId: [
          {required: true, message: this.$t('message.selectBankCard'), trigger: ["blur", "change"]}
        ],
        sender: [
          {required: true, message: this.$t('message.inputSender'), trigger: ["blur", "change"]},
          {min: 1, max: 320, message: this.$t('message.senderLengthError'), trigger: ["blur", "change"]},
          {type: 'email', message: this.$t('message.invalidEmail'), trigger: ["blur", "change"]}
        ],
        recipient: [
          {required: true, message: this.$t('message.inputRecipient'), trigger: ["blur", "change"]},
          {min: 1, max: 320, message: this.$t('message.recipientLengthError'), trigger: ["blur", "change"]},
          {type: 'email', message: this.$t('message.invalidEmail'), trigger: ["blur", "change"]}
        ],
        mailHost: [
          {required: true, message: this.$t('message.inputMailHost'), trigger: ["blur", "change"]},
          {min: 1, max: 255, message: this.$t('message.mailHostLengthError'), trigger: ["blur", "change"]},
          {pattern: /^[a-zA-Z0-9_.-]+$/, message: this.$t('message.invalidMailHost'), trigger: ["blur", "change"]}
        ],
        mailPort: [
          {required: true, message: this.$t('message.inputMailPort'), trigger: ["blur", "change"]},
          {
            type: 'integer',
            min: 1,
            max: 65535,
            message: this.$t('message.mailPortRangeError'),
            trigger: ["blur", "change"]
          }
        ],
        username: [
          {required: true, message: this.$t('message.inputMailUsername'), trigger: ["blur", "change"]},
          {min: 1, max: 320, message: this.$t('message.usernameLengthError'), trigger: ["blur", "change"]},
          {pattern: /^[a-zA-Z0-9_.-＠]+$/, message: this.$t('message.invalidUsername'), trigger: ["blur", "change"]}
        ],
        password: [
          {required: true, message: this.$t('message.inputPassword'), trigger: ["blur", "change"]},
          {min: 1, max: 100, message: this.$t('message.passwordLengthError'), trigger: ["blur", "change"]}
        ],
        enabled: [
          {
            required: true,
            type: 'enum',
            enum: [true, false],
            message: this.$t('message.enabledRequiredError'),
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  methods: {
    init() {
      if (this.action === "edit") {
        this.form = Object.assign({}, this.value);
      }
      this.getBankCardList();
    },
    closeDialog() {
      this.form = this.newFormData();
      this.$refs["form"].resetFields();
      this.$emit("update:show", false);
    },
    getBankCardList() {
      this.$axios
          .get("/mailMonitorInfo/selectBankCardOptions", {params: {}})
          .then((res) => {
            if (res.code === 200) {
              this.bankCardList = res.data;
              return true;
            } else {
              this.$notify.error({
                title: this.$t("text.prompt"),
                message: res.msg
              });
              return false;
            }
          });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const url = this.action === "add" ?
              "/mailMonitorInfo/mailMonitorInfoAdd" :
              "/mailMonitorInfo/mailMonitorInfoUpdate";

          this.axios
              .post(url, this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify.success({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                    type: "success"
                  });

                  this.$bus.$emit("refresh");
                  this.closeDialog();
                  return true;
                } else {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg
                  });
                  return false;
                }
              });
        } else {
          return false;
        }
      });
    },
    newFormData() {
      return {
        bankCardInfoId: "",
        sender: "",
        recipient: "",
        mailHost: "",
        mailPort: null,
        username: "",
        password: "",
        enabled: null
      };
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>